<template>
  <div class="table-row hover" @click="onClick">
    <TableCell
      v-for="(column, colIndex) of columns"
      :key="colIndex"
      v-profile-guard="column.action"
      :column="column"
      :data="data"
    ></TableCell>
  </div>
</template>

<script>
import TableCell from './TableCell';

export default {
  name: 'TableRow',
  components: {
    TableCell
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    columns: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onClick(ev) {
      this.$emit('click', ev);
    }
  }
};
</script>
